"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CrudListItem = _interopRequireDefault(require("../CrudListItem"));

var _CrudList = require("./CrudList.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CrudList = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CrudList, _React$PureComponent);

  var _super = _createSuper(CrudList);

  function CrudList(props) {
    var _this;

    _classCallCheck(this, CrudList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "buildListItems", function () {
      var _this$props = _this.props,
          crudButtons = _this$props.crudButtons,
          disableEdit = _this$props.disableEdit,
          disableFavorite = _this$props.disableFavorite,
          disableRemove = _this$props.disableRemove,
          listItems = _this$props.listItems,
          enumerateRows = _this$props.enumerateRows,
          indicatePrimary = _this$props.indicatePrimary,
          readOnly = _this$props.readOnly;
      return listItems.map(function (item, index) {
        return /*#__PURE__*/_react.default.createElement(_CrudListItem.default, {
          dataTestId: "generic-details-list-item-".concat(item.id),
          key: "generic-details-list-item-".concat(item.id),
          readOnly: readOnly,
          crudButtons: crudButtons,
          headerText: item.headerText,
          bodyText: item.bodyText,
          isPrimary: item.isPrimary,
          itemId: item.id,
          itemNumber: enumerateRows ? index + 1 : -1,
          crudClickHandler: _this.handleItemAction,
          disableEdit: disableEdit,
          disableFavorite: disableFavorite,
          disableRemove: disableRemove,
          indicatePrimary: indicatePrimary
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleItemAction", function (action, id) {
      return _this.fnMap[action](id);
    });

    _this.fnMap = {
      edit: props.editHandler,
      favorite: props.favoriteHandler,
      remove: props.removeHandler
    };
    return _this;
  }

  _createClass(CrudList, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          dataTestId = _this$props2.dataTestId;
      return /*#__PURE__*/_react.default.createElement(_CrudList.ListContainer, {
        className: className,
        dataTestId: dataTestId
      }, this.buildListItems());
    }
  }]);

  return CrudList;
}(_react.default.PureComponent);

_defineProperty(CrudList, "propTypes", {
  /** Styling classname */
  className: _propTypes.default.string,

  /**
   * Buttons to include on the row.
   *
   * Takes an array of button names with three possibilities:
   *  [
   *    'edit',
   *    'favorite',
   *    'remove',
   *  ]
   */
  crudButtons: _propTypes.default.arrayOf(_propTypes.default.string),

  /** Testing hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Disables Edit button */
  disableEdit: _propTypes.default.bool,

  /** Disables Favorite/Primary button */
  disableFavorite: _propTypes.default.bool,

  /** Disables Remove button */
  disableRemove: _propTypes.default.bool,

  /** Array of items to display */
  listItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    headerText: _propTypes.default.string,
    bodyText: _propTypes.default.arrayOf(_propTypes.default.string),
    isPrimary: _propTypes.default.bool,
    id: _propTypes.default.string
  })).isRequired,

  /** Called when an edit button press action happens on a row. Returns the itemId */
  editHandler: _propTypes.default.func,

  /** Determines whether the list will be numbered */
  enumerateRows: _propTypes.default.bool,

  /** Called when a primary/favorite button press action happens on a row. Returns the itemId */
  favoriteHandler: _propTypes.default.func,

  /** Determines whether to show primary indicator on non-enumerated lists */
  indicatePrimary: _propTypes.default.bool,

  /** Will remove the crud button toggle and behavior */
  readOnly: _propTypes.default.bool,

  /** Called when a remove button press action happens on a row. Returns the itemId */
  removeHandler: _propTypes.default.func
});

_defineProperty(CrudList, "defaultProps", {
  className: '',
  crudButtons: undefined,
  disableEdit: false,
  disableFavorite: false,
  disableRemove: false,
  editHandler: function editHandler() {},
  enumerateRows: false,
  favoriteHandler: function favoriteHandler() {},
  indicatePrimary: false,
  readOnly: false,
  removeHandler: function removeHandler() {}
});

var _default = CrudList;
exports.default = _default;